/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { DeviceModel } from '../../../core/device';
import { DateTime } from '../../../core/utils';

const TimeAiringInfo: FunctionComponent<{
    startTime?: string;
    endTime?: string;
}> = ({ startTime, endTime }) => {
    if (!(startTime && endTime)) return null;
    // <date> <start time> - <end time>
    const oAiredDate = new DateTime(startTime);
    const oStartTime = new DateTime(startTime);
    const oEndTime = new DateTime(endTime);
    return (
        <React.Fragment>
            <span className="uikit time-airing-info primary-text-style muted-color">
                {oAiredDate.strftime('%a %m/%D', DeviceModel.getTVProperties().getLang())}{' '}
                {oStartTime.to12HourClock()} {' - '}
                {oEndTime.to12HourClock()}
            </span>
        </React.Fragment>
    );
};

export default TimeAiringInfo;
